import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "list-bubbles mr-2" }
const _hoisted_3 = { class: "d-flex flex-column justify-content-between mr-auto" }
const _hoisted_4 = { class: "fs-14 text-dark" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "fs-14 pr-2" }, null, -1)
const _hoisted_6 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_7 = { class: "btn-stripped d-flex align-items-center text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")

  return (_openBlock(), _createBlock("li", _hoisted_1, [
    _createVNode("span", _hoisted_2, [
      _createVNode(_component_Button, {
        class: "p-button-rounded p-button-sm p-button-secondary no-click",
        style: {"--size-bubble":"40px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.userInitials), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.user.email), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.userRolesLabel), 1)
    ]),
    _hoisted_5,
    (_ctx.showRemove || _ctx.showRevokeBuildingAdmin)
      ? (_openBlock(), _createBlock(_component_ElDropdown, {
          key: 0,
          trigger: "hover",
          placement: "bottom-end",
          "popper-class": "el-dropdown__popper el-dropdown--context"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_ElDropdownMenu, { style: {"width":"240px"} }, {
              default: _withCtx(() => [
                (_ctx.showRevokeBuildingAdmin)
                  ? (_openBlock(), _createBlock(_component_ElDropdownItem, {
                      key: 0,
                      onClick: _withModifiers(_ctx.handleRevokeBuildingAdmin, ["prevent","stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t("AppResourceEP.RevokeBuildingAdmin")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.showRemove)
                  ? (_openBlock(), _createBlock(_component_ElDropdownItem, {
                      key: 1,
                      onClick: _withModifiers(_ctx.handleDeleteSharingUser, ["prevent","stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode("button", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Button, { class: "p-button-text p-button-icon p-button-sm text-gray" }, {
              default: _withCtx(() => [
                _createVNode(_component_InlineSvgScoped, {
                  src: require('@/assets/images/icons/icon-ellipsis-v.svg'),
                  "aria-label": "icon-ellipsis"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}